const User = ({ startColor, endColor, uid = "0", ...props }) => {
  const p0 = `paint0_${uid}`;
  const p1 = `paint1_${uid}`;
  const p2 = `paint2_${uid}`;
  const clip = `clip0_${uid}`;
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 307 307"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path={`url(#${clip})`}>
        <path
          d="M196.15 147.22C172.55 157.72 155.86 174.27 146.69 197.85C137.53 221.41 138.8 244.87 149.11 268.47H144.25C100.6 268.47 56.9501 268.47 13.3101 268.47C0.380095 268.47 -0.139904 268.02 0.0200955 254.91C0.490096 217.25 14.5101 185.57 42.3201 160.16C56.2401 147.45 72.3701 138.46 90.5001 133.22C92.0901 132.76 94.2101 132.92 95.7301 133.59C116.99 142.97 138.21 142.96 159.54 133.82C161.38 133.03 163.91 132.82 165.81 133.37C176.38 136.44 186.34 140.93 196.14 147.21L196.15 147.22Z"
          fill={`url(#${p0})`}
        />
        <path
          d="M153.39 229.93C153.44 187.68 187.8 153.41 230.1 153.4C272.31 153.4 306.73 187.81 306.76 230.03C306.78 272.36 272.08 306.99 229.81 306.8C187.56 306.62 153.34 272.19 153.39 229.92V229.93ZM223.52 186.07C221.59 186.93 219.84 187.6 218.19 188.46C204.9 195.36 200.41 212.15 208.6 224.69C213.68 232.47 221.07 236.19 230.32 236.53C237.01 236.78 242.02 241.47 242.66 247.81C243.32 254.33 239.46 259.95 233.16 261.62C225.44 263.67 218.41 258.38 217.24 249.63C216.6 244.89 213.96 242.49 209.99 243.02C206.28 243.52 204.1 246.65 204.54 251.03C205.42 259.8 209.32 267.07 217.22 270.96C222.22 273.42 224.62 275.95 223.89 281.68C223.48 284.88 226.38 287.24 229.53 287.48C232.82 287.73 235.68 285.63 236.29 282.32C236.56 280.87 236.6 279.32 236.43 277.85C236.11 275.14 236.93 273.74 239.71 272.66C249.67 268.8 255.92 259.05 255.57 248.66C255.2 237.67 248.38 228.32 238.01 225.07C235.21 224.19 232.16 224.03 229.2 223.7C222.26 222.93 217.08 217.33 217.26 210.65C217.43 204.13 222.6 198.66 228.97 198.24C236.2 197.77 241.69 202.32 242.69 209.6C242.81 210.46 242.88 211.34 243.07 212.19C243.83 215.42 246.33 217.32 249.57 217.16C252.75 217.01 255.27 214.8 255.42 211.5C255.53 209.17 255.29 206.74 254.69 204.49C252.18 195.01 245.77 189.21 236.72 186.2C235.59 181.04 239.03 173.54 229.96 172.76C225.41 172.37 224.32 174.9 223.53 186.06L223.52 186.07Z"
          fill={`url(#${p1})`}
        />
        <path
          d="M64.0001 63.8499C64.0701 28.4599 92.8301 -0.180133 128.11 -0.000132725C163.3 0.179867 191.68 28.7799 191.65 64.0299C191.62 99.3899 162.87 128.03 127.55 127.88C92.4001 127.73 63.9201 99.0399 63.9901 63.8499H64.0001Z"
          fill={`url(#${p2})`}
        />
      </g>
      <defs>
        <linearGradient
          id={p0}
          x1="98.0753"
          y1="132.958"
          x2="98.0753"
          y2="268.47"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color={startColor} />
          <stop offset="1" stop-color={endColor} />
        </linearGradient>
        <linearGradient
          id={p1}
          x1="230.075"
          y1="153.4"
          x2="230.075"
          y2="306.801"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color={startColor} />
          <stop offset="1" stop-color={endColor} />
        </linearGradient>
        <linearGradient
          id={p2}
          x1="127.82"
          y1="-0.000976563"
          x2="127.82"
          y2="127.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color={startColor} />
          <stop offset="1" stop-color={endColor} />
        </linearGradient>
        <clipPath id={clip}>
          <rect width="306.76" height="306.81" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default User;
